/*global VeloxViewController, VeloxWebView, moment, veloxScriptLoader*/

var pkg = require("../../../package.json") ;

var statsAdminController = new VeloxViewController({
    directory : "views/dashboard",
    name: "stats",
    route: "stats-admin" 
}) ;

module.exports = statsAdminController ;

statsAdminController.onCompute = function(){
    this.view.longTask(function(done){
        this.view.updateData() ;
        this.computeStats(this.data, function(err){
            if(err){ return done(err) ;}
            this.view.render() ;
            done() ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

var STATS_LIST = [
    "diagsByDayOfWeek", "diagsByMonth", "diagsByType", 
    "diagsByBasin", "diagsByDisinfectant", "diagsByVolume", "diagsByChlorine", "diagsByBromine",
    "diagsByChlorineSpa", "diagsByBromineSpa", 
    "diagsByRates", 
    "diagsByRatesSpa", 
    "customersByBasin",
    "customersByFilter", "customersByVolume", "customersByDisinfectant", "customersByMonth"
];

statsAdminController.prepareDataOnEnter = function(data, callback){
    var data = {
        viewCurrentPeriod: true,
        countries: [this.api.currentUser.lang||"fr-FR"],
        departments: [],
        dateStart: moment().startOf("year").format("YYYY-MM-DD"),
        dateEnd: moment().endOf("year").format("YYYY-MM-DD")
    } ;
    this.computeStats(data, function(err){
        if(err){ return callback(err) ;}
        data.STATS_LIST = STATS_LIST;
        return callback(null, data) ;
    });
};



statsAdminController.computeStats = function(data, callback){
    var calls = [] ;
    var search = {
        dateStart: data.dateStart,
        dateEnd: data.dateEnd,
        countries: data.countries,
        departments: data.departments,
        filters: data.filters,
        disinfectants: data.disinfectants,
        basins: data.basins,
    };
    STATS_LIST.forEach(function(statName){
        calls.push(function(cb){
            this.api.stats[statName](JSON.stringify(search), VeloxWebView.i18n.getLang(), function(err, res){
                if(err){ return cb(err) ; }
                res[0].name = VeloxWebView.tr("stats."+statName) ;
                data[statName] = res ;
                cb() ;
            }) ;
        }.bind(this)) ;
    }.bind(this)) ;
    VeloxWebView._asyncSeries(calls, function(err){
        if(err){ return callback(err) ; }

        if(data.viewPreviousPeriod || data.viewTwoPreviousPeriod){
            calls = [] ;
            var diffDays = moment(search.dateEnd).diff(moment(search.dateStart), 'days')
            search.dateEnd = moment(search.dateStart).subtract(1, "day").format("YYYY-MM-DD") ;
            search.dateStart = moment(search.dateEnd).subtract(diffDays, "day").format("YYYY-MM-DD") ;

            STATS_LIST.forEach(function(statName){
                calls.push(function(cb){
                    this.api.stats[statName](JSON.stringify(search), VeloxWebView.i18n.getLang(), function(err, allRes){
                        if(err){ return cb(err) ; }
                        res = allRes[0];
                        res.values.forEach(function(v){
                            var found = data[statName][0].values.some(function(v1){
                                return v1.name === v.name ;
                            });
                            if(!found){
                                data[statName][0].values.push({name: v.name, value: 0});
                            }
                        });
                        data[statName][0].values.forEach(function(v){
                            var found = res.values.some(function(v1){
                                return v1.name === v.name ;
                            });
                            if(!found){
                                res.values.push({name: v.name, value: 0});
                            }
                        }) ;
                        res.name = VeloxWebView.tr("stats.viewPreviousPeriod") ;
                        res.backgroundColor = "#AAA" ;
                        data[statName].push(res) ;

                        if(res.stack && allRes[1]){
                            //stacked with total
                            res = allRes[1];
                            res.values.forEach(function(v){
                                var found = data[statName][0].values.some(function(v1){
                                    return v1.name === v.name ;
                                });
                                if(!found){
                                    data[statName][0].values.push({name: v.name, value: 0});
                                }
                            });
                            data[statName][0].values.forEach(function(v){
                                var found = res.values.some(function(v1){
                                    return v1.name === v.name ;
                                });
                                if(!found){
                                    res.values.push({name: v.name, value: 0});
                                }
                            }) ;
                            res.name += " "+VeloxWebView.tr("stats.viewPreviousPeriod") ;
                            res.backgroundColor = "#c9cecf" ;
                            data[statName].push(res) ;
                        }
                        cb() ;
                    }) ;
                }.bind(this)) ;
            }.bind(this)) ;
            VeloxWebView._asyncSeries(calls, function(err){
                if(err){ return callback(err) ; }
                if(data.viewTwoPreviousPeriod){
                    calls = [] ;
                    var diffDays = moment(search.dateEnd).diff(moment(search.dateStart), 'days')
                    search.dateEnd = moment(search.dateStart).subtract(1, "day").format("YYYY-MM-DD") ;
                    search.dateStart = moment(search.dateEnd).subtract(diffDays, "day").format("YYYY-MM-DD") ;
        
                    STATS_LIST.forEach(function(statName){
                        calls.push(function(cb){
                            this.api.stats[statName](JSON.stringify(search), VeloxWebView.i18n.getLang(), function(err, allRes){
                                if(err){ return cb(err) ; }
                                res = allRes[0];
                                res.values.forEach(function(v){
                                    var found = data[statName][0].values.some(function(v1){
                                        return v1.name === v.name ;
                                    });
                                    if(!found){
                                        data[statName][0].values.push({name: v.name, value: 0});
                                    }
                                });
                                res.values.forEach(function(v){
                                    var found = data[statName][1].values.some(function(v1){
                                        return v1.name === v.name ;
                                    });
                                    if(!found){
                                        data[statName][1].values.push({name: v.name, value: 0});
                                    }
                                });
                                data[statName][0].values.forEach(function(v){
                                    var found = res.values.some(function(v1){
                                        return v1.name === v.name ;
                                    });
                                    if(!found){
                                        res.values.push({name: v.name, value: 0});
                                    }
                                }) ;
                                data[statName][1].values.forEach(function(v){
                                    var found = res.values.some(function(v1){
                                        return v1.name === v.name ;
                                    });
                                    if(!found){
                                        res.values.push({name: v.name, value: 0});
                                    }
                                }) ;
                                res.name = VeloxWebView.tr("stats.viewTwoPreviousPeriod") ;
                                res.backgroundColor = "#CCC" ;
                                data[statName].push(res) ;

                                if(res.stack && allRes[1]){
                                    //stacked with total
                                    res = allRes[1];
                                    res.values.forEach(function(v){
                                        var found = data[statName][0].values.some(function(v1){
                                            return v1.name === v.name ;
                                        });
                                        if(!found){
                                            data[statName][0].values.push({name: v.name, value: 0});
                                        }
                                    });
                                    res.values.forEach(function(v){
                                        var found = data[statName][1].values.some(function(v1){
                                            return v1.name === v.name ;
                                        });
                                        if(!found){
                                            data[statName][1].values.push({name: v.name, value: 0});
                                        }
                                    });
                                    data[statName][0].values.forEach(function(v){
                                        var found = res.values.some(function(v1){
                                            return v1.name === v.name ;
                                        });
                                        if(!found){
                                            res.values.push({name: v.name, value: 0});
                                        }
                                    }) ;
                                    data[statName][1].values.forEach(function(v){
                                        var found = res.values.some(function(v1){
                                            return v1.name === v.name ;
                                        });
                                        if(!found){
                                            res.values.push({name: v.name, value: 0});
                                        }
                                    }) ;
                                    res.name += " " + VeloxWebView.tr("stats.viewTwoPreviousPeriod") ;
                                    res.backgroundColor = "#dee0e1" ;
                                    data[statName].push(res) ;
                                }
                                cb() ;
                            }) ;
                        }.bind(this)) ;
                    }.bind(this)) ;
                    VeloxWebView._asyncSeries(calls, function(err){
                        if(err){ return callback(err) ; }
                        callback();
                    });
                }else{
                    callback() ;
                }
            }.bind(this));
        }else{
            callback() ;
        }
    }.bind(this)) ;
} ;

statsAdminController.onExportXls = function(ev){
    var dataId = ev.data.dataId ;
    var dataChart = this.data[dataId] ;
    var xlsData = {
        filename: dataChart[0].name+".xlsx",
        sheets: dataChart.map(function(serie){
            var lines = [[{ colspan: 2, value: serie.name }]] ;
            lines.push([]);
            serie.values.forEach(function(v){
                lines.push([v.name, Number(v.value)]);
            }) ;
            return {
                sheetName: serie.name,
                lines: lines
            }
        })
    }
    VeloxWebView.longTask(function(done){
        this.api.xls.exportXls(JSON.stringify(xlsData), done) ;
    }.bind(this)) ;
}


statsAdminController.onExportPdf = function(ev){
    this.view.longTask(function(done){
        veloxScriptLoader.load([
            {name: "template-"+VeloxWebView.i18n.getLang(),
                type: "plain",
                version: "1.0.0",
                localPath: "templates/html/statsTemplate.html",
            }
        ], function(err, results){
            if(err){ return done(err) ;}
            var html = results[0][0] ;

            var title = VeloxWebView.tr("stats.statistics") ;

            var filters = [] ;
            if(this.data.dateStart){
                filters.push(VeloxWebView.tr("stats.dateFrom")+" <b>"+moment(this.data.dateStart).format("L")+"</b>") ;
            }
            if(this.data.dateEnd){
                filters.push(VeloxWebView.tr("stats.dateEnd")+" <b>"+moment(this.data.dateEnd).format("L")+"</b>") ;
            }
            if(this.data.countries && this.data.countries.length>0){
                filters.push(VeloxWebView.tr("stats.countries") +" <b>"+this.data.countries.map(function(c){
                    if(c === "fr-FR"){
                        return VeloxWebView.tr("stats.france");
                    }else if(c === "de-DE"){
                        return VeloxWebView.tr("stats.germany");
                    }else if(c === "es-ES"){
                        return VeloxWebView.tr("stats.spain");
                    }
                }).join(", ")+"</b>") ;
            }
            if(this.data.departments && this.data.departments.length>0){
                filters.push(VeloxWebView.tr("stats.departments") +" <b>"+this.data.departments.join(", ")+"</b>") ;
            }
            if(this.data.filters && this.data.filters.length>0){
                filters.push(VeloxWebView.tr("stats.filters") +" <b>"+this.data.filters.map(function(c){
                    return VeloxWebView.tr("fields.values.pool.p_filter."+c) ;
                }).join(", ")+"</b>") ;
            }
            if(this.data.disinfectants && this.data.disinfectants.length>0){
                filters.push(VeloxWebView.tr("stats.disinfectants") +" <b>"+ this.data.disinfectants.map(function(c){
                    return VeloxWebView.tr("fields.values.pool.p_disinfectant."+c) ;
                }).join(", ")+"</b>") ;
            }
            if(this.data.basins && this.data.basins.length>0){
                filters.push(VeloxWebView.tr("stats.basins") +" <b>"+ this.data.basins.map(function(c){
                    return VeloxWebView.tr("fields.values.diag.d_pool_or_spa."+c) ;
                }).join(", ")+"</b>") ;
            }

            html = html.replace("@stats@", ev.data.map(function(stat){
                // return '<img src="'+stat.dataUrl+'" style="max-width: 90%; height: '+stat.size+'px;margin-left: auto; margin-right: auto; margin-bottom: 10px"/>' ;
                return '<img src="'+stat.dataUrl+'" style="max-width: 90%; margin-bottom: 30px"/>' ;
            }).join("\n")) ;

            html = html.replace("@version@", pkg.humanVersion) ;
            html = html.replace("@title@", title) ;
            html = html.replace("@filters@", filters.join(" ")) ;
            html = html.replace("@date@", VeloxWebView.tr("dashboard.editedOn")+' '+moment().format("L")) ;

            if(window.native){
                //desktop native
                window.native.pdf.genAndOpenReport({html: html, filename: title+".pdf", lang: VeloxWebView.i18n.getLang(), noFooter: true}, done) ;
            }else{
                this.api.pdf.gen(title+".pdf", html, VeloxWebView.i18n.getLang(), true, done) ;
            }
        }.bind(this));
    }.bind(this)) ;
};